import type {
  ProjectsBatchEditPropertyKey,
  ProjectsBatchEditSelectProperties,
} from "./projects-batch-edit.type";

import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useProjectsBatchEditProperties = () => {
  const { t } = useTranslation();

  const [currentProperty, setCurrentProperty] =
    useState<ProjectsBatchEditPropertyKey | null>(null);

  const properties: ProjectsBatchEditSelectProperties = [
    {
      value: "users",
      label: t("global:assignForm.users.label"),
    },
  ];

  return {
    properties,
    currentProperty,
    setCurrentProperty,
  };
};
